export const SERVICES = {
    RootStore: Symbol.for('RootStore'),
    AppStore: Symbol.for('AppStore'),
    HelpHero: Symbol.for('HelpHero'),
    FirebaseApp: Symbol.for('FirebaseApp'),
    CoolsStore: Symbol.for('CoolsStore'),
    Sentry: Symbol.for('Sentry'),
};
